import {defineStore} from 'pinia';
import axios from "axios";

export const appStore = defineStore('appStore', {
    state: () => ({
        hideHeaderMessageState: false,
        structuredData: null
    }),
    getters: {
        appTitle() {
            if (this.structuredData) {
                if (this.structuredData.name) {
                    return this.structuredData.name;
                } else if (this.structuredData.headline) {
                    return this.structuredData.headline;
                }
                if (this.structuredData.mainEntity) {
                    return this.structuredData.mainEntity.name;
                }
            }
            return null;
        },
        appDescription() {
            if (this.structuredData) {
                if (this.structuredData.description) {
                    return this.structuredData.description;
                }
                if (this.structuredData.mainEntity) {
                    return this.structuredData.mainEntity.description;
                }
            }
            return null;
        },
        appImage() {
            if (this.structuredData) {
                if (this.structuredData.image) {
                    return this.structuredData.image;
                }
                if (this.structuredData.mainEntity) {
                    return this.structuredData.mainEntity.image;
                }
            }
            return null;
        }
    },
    actions: {
        hideHeaderMessage() {
            this.hideHeaderMessageState = true;
        },
        setupStructuredData(type, id) {
            axios.get(`/api/sd/${type}/${id}`).then(response => {
                this.structuredData = response.data;
            }).catch((e) => {
                console.error(e);
            });
        }
    }
})